import { TypedDocumentNode, gql } from '@apollo/client';
import { faUserCheck } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getSameNationalityRule_so5Rules } from './__generated__/getSameNationalityRule.graphql';

export const getSameNationalityRule = withFragments(
  (
    rules: getSameNationalityRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.sameNationality;
    if (!rule) {
      return null;
    }

    return {
      id: 'sameNationality',
      label: (
        <FormattedMessage
          id="Rules.sameNationality"
          defaultMessage="Same nationality for all players"
        />
      ),
      icon: (
        <FontAwesomeIcon
          icon={faUserCheck}
          color="var(--c-rivals-win)"
          width="16"
          height="16"
        />
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getSameNationalityRule_so5Rules on So5Rules {
        id
        sameNationality
      }
    ` as TypedDocumentNode<getSameNationalityRule_so5Rules>,
  }
);
